export default __webpack_public_path__ + "static/img-project-4-2fb7d39bfaaee39161a0b07aeb02d216.png";